import axios from "axios";
import baseUrl from "../config/baseURL";
import { getAuthToken } from "../services/auth";

export const getLeadNotes = async (organization_id: any, lead_id: any) => {
    let token = await getAuthToken();
    try {
        if(token){
            let header_token = "Bearer " + token.data;
            const headers = {
                Authorization: header_token,
            };
        try {
            const endpoint = `${baseUrl}/core/organizations/${organization_id}/leads/${lead_id}/notes`;
            const response = await axios.get(endpoint,{ headers });
            if (response.status>=200 && response.status <=400) {
            return {"success":true, "data": response?.data};
            } else {
            console.error("Data retrieval failed here:", response, response.data);
            return {"success":false, "data": response?.data};
            }
        } catch (error) {
            console.error("An unexpected error occurred:", error);
            return {"success":false, "data": error};
        }
        }else{
        return {"success":false, "data": "error: Token does not exist"};
        }
        
    }catch (error) {
        console.error("Unexpected error occurred while fetching the leads:", error);
        return {"success":false, "data": undefined};
    }
};

export const getLeadNote = async (organization_id: any, lead_id: any, note_id: any) => {
  let token = await getAuthToken();
  try {
      if(token){
          let header_token = "Bearer " + token.data;
          const headers = {
              Authorization: header_token,
          };
      try {
          const endpoint = `${baseUrl}/core/organizations/${organization_id}/leads/${lead_id}/notes/${note_id}`;
          const response = await axios.get(endpoint,{ headers });
          if (response.status>=200 && response.status <=400) {
          return {"success":true, "data": response?.data};
          } else {
          console.error("Data retrieval failed here:", response, response.data);
          return {"success":false, "data": response?.data};
          }
      } catch (error) {
          console.error("An unexpected error occurred:", error);
          return {"success":false, "data": error};
      }
      }else{
      return {"success":false, "data": "error: Token does not exist"};
      }
      
  }catch (error) {
      console.error("Unexpected error occurred while fetching the leads:", error);
      return {"success":false, "data": undefined};
  }
};

export const saveLeadNote = async (
  orgId: string,
  leadId: string,
  content: string,
) => {
  const leadNote = {
    content,
  };
  let token = await getAuthToken();
  let headers;

  if(token){
    let header_token = "Bearer " + token.data;
    headers = {
        Authorization: header_token,
    };
  }

  try {
    const endpoint = `${baseUrl}/core/organizations/${orgId}/leads/${leadId}/notes/`;
    const response = await axios.post(endpoint, leadNote, {headers});

    if (response.status === 201) {
      console.log("Lead Note created successfully:", response.data);
      return { success: true, data: response.data };
    } else {
      console.error("Failed to create lead note:", response.data);
      return { success: false, data: response.data };
    }
  } catch (error: any) {
    console.error("An unexpected error occurred:", error?.response?.data || error);
    return { success: false, data: error?.response?.data || error };
  }
};

export const deleteLeadNote = async (orgId: string, leadId: string, noteId: string) => {
  let token = await getAuthToken();
  let headers;

  if(token){
    let header_token = "Bearer " + token.data;
    headers = {
        Authorization: header_token,
    };
  }
    try {
      const endpoint = `${baseUrl}/core/organizations/${orgId}/leads/${leadId}/notes/${noteId}/`;
      const response = await axios.delete(endpoint, {headers});
  
      if (response.status === 204) {
        console.log("Lead deleted successfully");
        return { success: true, data: "Lead Note deleted successfully" };
      } else {
        console.warn("Unexpected response status:", response.status);
        return { success: false, data: response.data };
      }
    } catch (error: any) {
      console.error("Error deleting lead note:", error?.response?.data || error);
      return { success: false, data: error?.response?.data || error };
    }
  };